export default "__VITE_ASSET__d9a45595__"